<template>
  <div style="height: 100dvh">
    <mobHeader />
    <div class="mobile-body">
      <div class="headtxt-box p-2 px-3">Dashboard</div>
      <div class="mob-pan-body p-2 mt-3">
        <div v-if="LoaderStatus">
          <div v-for="i in loopvar" :key="i" class="pan-mob-card mt-2">
            <b-skeleton class="w-75 m-3"></b-skeleton>
          </div>
        </div>
        <div v-if="LoaderStatus == false">
          <div
            @click="schedule()"
            class="
              pointer
              pan-mob-card
              mt-2
              d-flex
              justify-content-between
              align-items-center
              p-3
            "
          >
            <div class="card-head-txt">Scheduled Interviews</div>
            <div>
              <img
                src="../../assets/panelLog/mob-design/right-arrow-mob.svg"
                alt=""
              />
            </div>
          </div>
          <div
            @click="feedbackProvided()"
            class="
              pointer
              pan-mob-card
              mt-2
              d-flex
              justify-content-between
              align-items-center
              p-3
            "
          >
            <div class="card-head-txt">Feedback Provided</div>
            <div>
              <img
                src="../../assets/panelLog/mob-design/right-arrow-mob.svg"
                alt=""
              />
            </div>
          </div>
          <div
            @click="resumeScreening()"
            class="
              pointer
              pan-mob-card
              mt-2
              d-flex
              justify-content-between
              align-items-center
              p-3
            "
          >
            <div class="card-head-txt">Resume Screening</div>
            <div>
              <img
                src="../../assets/panelLog/mob-design/right-arrow-mob.svg"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mobilePanelMixins from "../../views/panelLogin/mobilePanelMixins.js";
import mobHeader from "../../components/fixedcomponents/MobHeader.vue";

export default {
  components: {
    mobHeader,
  },
  data() {
    return {
      loopvar: 2,
      LoaderStatus: false,
      payload: {},
      timer: null,
      searchname: "",
      showGiveFeebackButton: false,
      scheduleInterviewPage: false,
      schedulePage: false,
      feedbackPage: false,
      currentPage: 1,
      pageCount: 10,
      feedbackValue: "false",
      statusValue: "createdAt",
      sortOrder: false,
      totalScheduledInterviews: null,
      showLoader: false,
      showfeedbackSpinner: false,
      totalFeedbackProvided: null,
      allpaneldata: [],
      feedbackHistory: [],
      total: null,
      pageEnd: null,
    };
  },
  mixins: [mobilePanelMixins],

  methods: {
    feedbackProvided() {
      this.$router.push({
        name: "mobpanelDetails",
        query: {
          status: "feedbacktab",
        },
      });
      this.getAllPanelCandidate("true");
      this.searchname = "";
      this.payload.feedback = "";
      this.currentPage = 1;
      this.scheduleInterviewPage = true;
      this.feedbackPage = true;
      this.schedulePage = false;

      this.allpaneldata = [];
    },
    schedule() {
      this.$router.push({
        name: "mobpanelDetails",
        query: {
          status: "scheduletab",
        },
      });
      this.searchname = "";
      this.payload.feedback = "";
      this.currentPage = 1;

      this.scheduleInterviewPage = true;
      this.schedulePage = true;
      this.feedbackPage = false;

      this.allpaneldata = [];
      this.getAllPanelCandidate("false");
    },
    resumeScreening() {
      this.$router.push({
        name: "mobresumeScreening",
      });
    },
  },
};
</script>

<style>
.mobile-feedback-shimmer {
  color: #000;
}
.panlg-overflow {
  overflow: auto;
  border-radius: 5px;
  border: 1px solid #ebebeb;
  background: #fff;
}

.h-95 {
  height: 95%;
}

.panlg-footer {
  height: 9%;
  border-radius: 5px;
  background: #fff;
  border-top: 1px solid #ebebeb;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.panlg-blueTxt {
  color: #257cff;
  font-size: 12px;
  font-weight: 400;
}

.panlg-blueBack {
  border-radius: 5px;
  background: rgba(242, 242, 242, 0.98);
  padding: 10px;
}

.panlg-whiteCard {
  border-radius: 5px;
  border: 1px solid #ebebeb;
  background: #fff;
}

.panlg-greentxt {
  color: #038e00;
  font-size: 12px;
  font-weight: 500;
}

.panlg-redtxt {
  color: #d90606;
  font-size: 12px;
  font-weight: 500;
}

.panlg-yellowtxt {
  color: #ffc145;
  font-size: 12px;
  font-weight: 500;
}

.panlg-greytxt {
  color: #6d6d6d;
  font-size: 12px;
  font-weight: 400;
}

.mob-plainbtn {
  color: #72738e;

  font-size: 14px;

  font-weight: 500;

  background-color: transparent;
}

.mob-greybtn {
  border-radius: 3px;
  background: #72738e;
  color: #fff;

  font-size: 13px;

  font-weight: 500;
}

.mobile-header {
  background: #fff;
  box-shadow: 0px 4px 20px 0px #000;
  height: 8%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mobile-body {
  height: 92%;
  background: #e9ecef;
  padding: 15px;
}

.small-txt-head {
  color: #72738e;
  font-size: 18px;
  font-weight: 500;
}

.big-txt-head {
  color: #72738e;
  font-size: 21px;
  font-weight: 600;
}

.panlg-card {
  border-radius: 5px;
  border: 1px solid #ebebeb;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.schedule-overflow {
  height: 85%;
  overflow: auto;
}

.w-30 {
  width: 30%;
}

.w-20 {
  width: 20%;
}

.panel-nofeedback-text {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  color: #696969;
}
.mobile-feedbk-round-head-jd {
  font-weight: 600;
  font-size: 11px;
  color: #545454;
}
.panlg-input {
  border-radius: 3px;
  border: 0.5px solid #c4c4c4;
  background: #fff;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2) inset;
  padding: 5px 43px 7px 27px;
}
</style>
